import {Injectable} from "@angular/core";
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {catchError, map, Observable, throwError} from "rxjs";
import {Router} from "@angular/router";
import {RcpService} from "../services/rcp/rcp.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private router: Router,
                private rcpService: RcpService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            map((event: HttpEvent<any>) => {
                return event;
            }),
            catchError((error: any) => {
                const isTemporalPassword = this.rcpService.isTemporalPassword();
                if (error?.status === 401 && !isTemporalPassword) {
                    sessionStorage.clear()
                    this.router.navigate(['/login']);
                }
                return throwError(error);
            })
        );
    }
}
